const { parentTag } = require('../../config');

import api from './request';

export function apiGetUserInfo() {
  return api.get<Project.IUserInfo>('/nr-qiankun-center/sso/getUserInfo');
}

/**
 * 获取主应用下所有子应用列表
 */
export function apiGetUserProjectListByGroup() {
  return api
    .get<Project.TProjectList>(
      `/nr-qiankun-center/project/listUserCategoryProject?parentTag=${parentTag}`
    )
    .then((res) => {
      (res.data || []).forEach((project: Project.IProjectItem) => {
        (project.data || []).forEach((subItem: Project.ISubProject) => {
          delete subItem.url;
        });
      });
      return res;
    });
}

/**
 * 获取登录用户拥有的国家/区域列表
 */
export function apiGetRegionList(projectTag: string) {
  return api.get<Project.IRegionData[]>(
    `/nr-qiankun-center/user/listArea?projectTag=${projectTag}`
  );
}
